import { Row, Col, Progress } from "antd";
import Logo from "../../../../assets/images/logo-without-bg.png";
import leftLoading from "../../../../assets/images/opo.gif";

const SyncLoadingScreen = ({
  colorVariable,
  formattedDateTime,
  clock1,
  percent,
  productCategoryPercentage,
  productPercentage,
  promotionPercentage,
}) => {
  return (
    <>
      <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
        <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
          <Col span={6}>
            <img src={Logo} style={{ height: "2.8vw", paddingLeft: "1vw", paddingTop: "1vh" }} />
          </Col>
          <Col span={18} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "1vw", fontSize: "1vw" }}>
            <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{formattedDateTime}</div>
            <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{clock1}</div>
          </Col>
        </Row>
        <div style={{ display: "flex", height: "90vh" }}>
          <div
            style={{
              width: "48%",
              background: "#fff",
              height: "83vh",
              margin: "1.5%",
              marginRight: 0,
              borderRadius: "10px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "1vw" }}>
              <div style={{ position: "relative", width: "13vw", height: "13vw" }}>
                <img
                  src={leftLoading}
                  alt="Loading"
                  style={{
                    width: "100%",
                    height: "100%",
                    // transform: `rotate(${rotation}deg)`,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "1.5em",
                    fontWeight: "500",
                    color: "#0F0718",
                  }}
                >
                  {percent}
                </div>
              </div>
              <p style={{ color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "2.5em", marginBottom: 0 }}>Till loading in process</p>
              {/* <p style={{color:"#D73A48",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw",marginBottom:0}}>{formatTime(time)}</p>
           <p style={{color:"#0F0718",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw"}}>Minutes Left</p> */}
            </div>
          </div>
          <div style={{ width: "48%", height: "83vh", background: "#fff", margin: "1.5%", borderRadius: "10px", color: "#0F0718" }}>
            <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "17vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>
              Product Categories
            </p>
            <Progress
              strokeColor={{
                from: "#2F3856",
                to: "#2F3856",
              }}
              // showInfo={false}
              style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
              percent={productCategoryPercentage}
              status="active"
            />
            <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Products</p>
            <Progress
              strokeColor={{
                from: "#2F3856",
                to: "#2F3856",
              }}
              // showInfo={false}
              style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
              percent={productPercentage}
              status="active"
            />
            <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Promotions</p>
            <Progress
              strokeColor={{
                from: "#2F3856",
                to: "#2F3856",
              }}
              // showInfo={false}
              style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
              percent={promotionPercentage}
              status="active"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SyncLoadingScreen;
